module.exports = __webpack_public_path__ + "static/media/9.b0a4cff4.jpg";